import { get, handleError } from '@/lib/http-adapter';
import { FaqItem } from '@/components/faq-accordion';

type FaqEntityType = 'CLASS' | 'CLASS_PACK' | 'SUBSCRIPTION' | 'GIFT_CARD';

interface GetFaqsParams {
  entity_type: FaqEntityType;
  entity_id?: string;
  slug?: string;
}

export const getFaqs = async (
  params: GetFaqsParams
): Promise<FaqItem[]> => {
  try {
    const queryParams: Record<string, string> = {
      entity_type: params.entity_type,
    };

    if (params.entity_id) {
      queryParams.entity_id = params.entity_id;
    }
    if (params.slug) {
      queryParams.slug = params.slug;
    }

    const response = await get<{
      faqs: { faq_id: string; question: string; answer: string; order: number }[];
    }>('/public/faqs', { params: queryParams });

    return (response?.faqs ?? [])
      .map(({ question, answer, order }) => ({
        question,
        answer,
        order,
      }))
      .sort((a, b) => a.order - b.order);
  } catch (error) {
    handleError(error);
    return [];
  }
};
